export enum STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
  ALL = -1,
}

export enum GENDER {
  MALE = 1,
  FEMALE = 0,
}

export const PAGE_SIZES = [10, 20, 30, 50, 100];

export enum CHANGE_STATUS {
  UPDATE = 1,
  ACTIVE = 2,
  INACTIVE = 3,
  RESET = 4,
  DETAIL = 5,
}

export enum PROMOTION_CAMPAIGN_TYPE {
  COMBO = 1,
  TICKET = 2,
  RECHARGE_PACKAGE_MILESTONES = 3,
  MEMBERSHIP_LEVEL = 4,
  CUSTOMER_DISCOUNTS = 5,
  AREA_DISCOUNTS = 6,
}

export const dataAppType = [
  { id: "1,1", name: "EMPLOYEE - ANDROID" },
  { id: "1,2", name: "EMPLOYEE - IOS" },
  { id: "2,1", name: "CUSTOMER - ANDROID" },
  { id: "2,2", name: "CUSTOMER - IOS" },
];

export const dataAppSelected = [
  { id: "-1,-1", name: "Tất cả" },
  { id: "1,1", name: "EMPLOYEE - ANDROID" },
  { id: "1,2", name: "EMPLOYEE - IOS" },
  { id: "2,1", name: "CUSTOMER - ANDROID" },
  { id: "2,2", name: "CUSTOMER - IOS" },
];
